<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.fornecedor"
        ref="DataTable"
        sort-by="nomeFantasia"
    >
        <template v-slot:cell(cnpj)="row">
            {{ row.value | cnpj }}
        </template>

        <template v-slot:cell(telefone)='row'>
            {{ row.value | formatPhoneOrCellPhone }}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-fornecedor-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-fornecedor"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-cadastro-fornecedor"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

export default {
    created() {

        this.repositories = {
            fornecedor: this.getConectaSusRepository('cadastro.fornecedor')
        }
    },
    computed: {

        fields() {

            return [
                {
                    name: 'cadastroFornecedor.nomeFantasia',
                    key: 'nomeFantasia',
                    label: 'Nome fantasia',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroFornecedorCategoria.nome',
                    key: 'categoriaNome',
                    label: 'Categoria',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroFornecedor.cnpj',
                    key: 'cnpj',
                    label: 'CNPJ',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroMunicipio.nome',
                    key: 'municipioNome',
                    label: 'Município',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroFornecedorTelefone.numero',
                    key: 'telefone',
                    label: 'Telefone',
                    searchable: false,
                    sortable: true
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    filters: {
        cnpj: formats.formatCnpj,
        formatPhoneOrCellPhone: formats.formatPhoneOrCellPhone,
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.fornecedor.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o fornecedor?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>